import React, { useEffect } from 'react';
import LandingFooter from '../../components/layouts/LandingFooter';
import AOS from 'aos';
import 'aos/dist/aos.css';

const About: React.FC = () => {
  const [lang] = React.useState(localStorage.getItem('locale') || 'en');

  useEffect(() => {
    AOS.init({ duration: 1000, delay: 300 });
  }, []);

  const imgAr = lang === 'ar' ? '-ar' : '';

  return (
    <>
      <div className="d-flex flex-column bg-base-light flex-center w-100 min-h-300px z-index-n1 min-h-lg-450px px-9 bg-leaves">
        <img src="/media/lemon.png" className="w-325px lemon-img position-absolute right-0 me-15 z-index-0 img-responsive" alt="" />
        <img src="/media/vegetable.png" className="vegetable-img position-absolute z-index-0 img-responsive" alt="" />
        <div className="row w-100 mx-auto">
          <div className="col-md-8 mx-auto text-center">
            <div className="mb-5 mb-lg-10 pb-10 py-lg-5">
              <h1 className="text-base-dark lh-base font-bold fs-1x fs-lg-3x mb-5 text-uppercase" data-aos="fade-up">About Us</h1>
              <br />
              <p className="text-base-dark fs-lg-3" style={{ fontFamily: 'NeulisAlt-Light' }} data-aos="fade-up">
                Fesilah is a comprehensive platform dedicated to helping you keep your plants healthy and thriving.
              </p>
              <img src="/media/vegetable2.png" className="w-325px vegetable2-img position-absolute z-index-0 img-responsive" alt="" />
              <img src="/media/tomato.png" className="tomato-img position-absolute right-0 z-index-0 img-responsive" alt="" />
              <br />
            </div>
          </div>
        </div>
      </div>
      <img src="/media/Wave.png" className="w-100 curve" alt="" />
      <div className="mb-n10 mb-lg-n20 z-index-2 min-h-300px inner-box">
        <div className="container">
          <div className="row mt-5">
            <div className="col-12 col-md-8 mx-auto shadow bg-white p-15 mb-15 inner-content">
              <video height="350px" className="mobile-video" width="100%" data-aos="zoom-in" controls autoPlay>
                <source src="/media/about-us.mp4" type="video/mp4" />
                Your browser does not support HTML video.
              </video>
              <p className="text-center fs-lg-5 mt-15" data-aos="fade-up">
                Fesilah provides expert agricultural consulting services to help you maintain healthy plants.
              </p>
              <p className="text-center fs-lg-5 mt-15" data-aos="fade-up">
                Our platform connects you with experienced agricultural experts who can guide you through all aspects of plant care.
              </p>
              <p className="text-center text-base-dark font-light mt-15 fs-lg-6" data-aos="fade-up">
                We are committed to promoting sustainable agriculture and helping individuals and communities cultivate thriving gardens.
              </p>
            </div>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default About;
















